import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Lock, Loader2 } from 'lucide-react';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function GuestCheckoutDialog({ item, onClose }) {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await fetch(`${API}/payments/guest-checkout`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name,
          email,
          package_type: item.package_type,
          course_id: item.course_id,
          plan_id: item.plan_id,
        }),
      });
      const data = await res.json();
      if (res.ok && data.redirect_url) {
        window.location.href = data.redirect_url;
      } else {
        toast.error(typeof data.detail === 'string' ? data.detail : 'Could not start checkout. Please try again.');
        setLoading(false);
      }
    } catch {
      toast.error('Connection error. Please try again.');
      setLoading(false);
    }
  };

  return (
    <Dialog open={!!item} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="guest-checkout-dialog" className="bg-white">
        <DialogHeader>
          <DialogTitle className="text-2xl font-bold text-[#0B0B0B]" style={{ fontFamily: 'Clash Display' }}>
            You're 30 seconds away
          </DialogTitle>
          <DialogDescription>Enter your details to get instant access after payment.</DialogDescription>
        </DialogHeader>
        {item && (
          <div className="bg-[#F4EFE6] rounded-xl p-4 flex justify-between items-center" data-testid="guest-checkout-summary">
            <span className="font-semibold text-[#0B0B0B]">{item.title}</span>
            <span className="text-right">
              <span className="font-bold text-[#0B0B0B] block">{item.display_price || `R${Number(item.price).toFixed(0)}`}</span>
              {item.display_price && <span className="text-xs text-gray-500">charged as R{Number(item.price).toFixed(0)} ZAR</span>}
            </span>
          </div>
        )}
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <Label htmlFor="guest-name">Your Name</Label>
            <Input
              id="guest-name"
              data-testid="guest-checkout-name-input"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              className="mt-1"
              placeholder="First name"
            />
          </div>
          <div>
            <Label htmlFor="guest-email">Email</Label>
            <Input
              id="guest-email"
              type="email"
              data-testid="guest-checkout-email-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="mt-1"
              placeholder="you@email.com"
            />
            <p className="text-xs text-gray-500 mt-1">Your program access + receipt will be sent here.</p>
          </div>
          <Button
            type="submit"
            data-testid="guest-checkout-submit-btn"
            disabled={loading}
            className="w-full bg-[#0B0B0B] text-white hover:bg-[#161616] rounded-full py-6 text-base font-bold"
          >
            {loading ? (
              <><Loader2 className="w-4 h-4 mr-2 animate-spin" /> Redirecting to payment...</>
            ) : (
              <><Lock className="w-4 h-4 mr-2" /> Continue to Secure Payment</>
            )}
          </Button>
        </form>
        <p className="text-center text-xs text-gray-500">
          No account needed — we'll set up your access automatically after payment. Secured by Yoco.
        </p>
      </DialogContent>
    </Dialog>
  );
}
